import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import { Trans } from 'react-i18next';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import Emphasize from 'components/Emphasize';

function Notification() {
    const themeStyle = usePromoSettingThemeStyle();
    const lotteryParticipant = useSelector(s => s.lotteryParticipant);
    const { isMgmShare } = useSelector(s => s.flags);
    const { lotteryParticipant: mgmLotteryParticipant = {} } = useSelector(s => s.mgmReferral);

    const currentLotteryParticipant = (function (isMgmShare) {
        if (isMgmShare) {
            return mgmLotteryParticipant;
        }
        return lotteryParticipant;
    })(isMgmShare);

    const { hasAnnounced: prizeAnnounce } = currentLotteryParticipant;

    const annouce = Boolean(prizeAnnounce) && (
        <Message color={themeStyle.titleColor}>
            <Trans
                i18nKey="desc.please_login_check_prize"
                components={<Emphasize color={themeStyle.buttonBgColor} />}
            />
        </Message>
    );

    return (
        Boolean(annouce) && (
            <div css={[wrapperStyle, css(`background-color: ${themeStyle.contentBgColor};`)]}>
                {annouce}
            </div>
        )
    );
}

export default Notification;

const wrapperStyle = css`
    background-color: #ffffff;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    overflow: hidden;
`;

const Message = ({ children, color }) => {
    return <div css={[messageStyle, css(`color: ${color};`)]}>{children}</div>;
};

const messageStyle = css`
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 0.875rem;
    font-weight: 500;
`;
